import { useEffect, useState } from 'react'
import { UiBreadcrumb, UiCard, UiCardBody, UiCardHeader } from 'components/common'
import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react'
import { getAssetUrl } from 'lib'
import { format as formatDate } from 'date-fns'
import { useAppContext } from 'hooks/useAppContext'
import { getPayoutHistories } from 'api/payoutHistoryApi'

const BreadcrumbNav = [
  {
    label: 'Report History',
    isCurrentPage: true
  }
]

export const ReportHistory = () => {
  const { createToast } = useAppContext()
  const [isLoading, setIsLoading] = useState(false)
  const [histories, setHistories] = useState([])

  const load = async () => {
    setIsLoading(true)
    try {
      const response = await getPayoutHistories()
      setHistories(response)
      setIsLoading(false)
    } catch (err) {
      createToast('error', 'Error', 'Failed to load history.')
      setIsLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [])

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Report History</Heading>
        </Flex>
        <UiCard borderRadius={0}>
          <UiCardHeader bg="gray.500" p={4}>
            <Text fontWeight="bold" color="white">Histories</Text>
          </UiCardHeader>
          <UiCardBody>
            {isLoading ? (
              <Text>Loading ...</Text>
            ) : (
              histories.length > 0 ? (
                histories.map(history => {
                  return (
                    <Flex key={history.id} justifyContent="space-between" alignItems="center" maxW="700px" my={2}>
                      <Text flex="2" fontSize="sm">{history.type}</Text>
                      <Text flex="2" fontSize="sm">Generated at {formatDate(new Date(history.createdAt), 'MM/dd/yyyy hh:mm aaa')}</Text>
                      <Box flex="1">
                        <Button size="xs" colorScheme="blue" onClick={() => window.open(getAssetUrl(history.pdf), '_blank')}>View PDF</Button>
                      </Box>
                    </Flex>
                  )
                })
              ) : (
                <Text>No histories.</Text>
              )
            )}
          </UiCardBody>
        </UiCard>
      </Box>
    </>
  )
}
